var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValidationInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C7C7C7",
  d: "M0 0h32v32H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M16.6 18.939h-1.374v-3.75H16.6zm-1.374-6.042H16.6v1.459h-1.375zM21.205 16a5.3 5.3 0 0 1-5.292 5.291A5.3 5.3 0 0 1 10.621 16a5.3 5.3 0 0 1 5.292-5.292A5.3 5.3 0 0 1 21.205 16m.958 0a6.25 6.25 0 1 0-12.5 0 6.25 6.25 0 0 0 12.5 0",
  clipRule: "evenodd"
})));
export default SvgValidationInfo;